// types
import { TP_HeatingGenerator } from './types'
// components
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { SmallPanelTrend as PipePanelTrend } from '../../../SubPlants/SP_Pipe'
import { SmallPanelTrend as PufferPanelTrend } from '../../../SubPlants/SP_Puffer'
import { SmallPanel as PipePanel } from '../../../SubPlants/SP_Pipe'
import { SmallPanel as HeatingCoilPanel } from '../../../SubPlants/SP_HeatingCoil'
import { SmallPanel as HeatingGeneratorPanel } from '../../../SubPlants/SP_HeatingGenerator'
import { SmallPanel as PufferPanel } from '../../../SubPlants/SP_Puffer'
import { OperatorPanel as EfficiencyPanel } from '../../../Utils/Efficiency/OperatorPanel'
import { schema as schemaMultistateSwitch, SmallPanel as MSSwitchSmallPanel } from '../../../Devices/MultiStateSwitch'
import { LoadingView } from "../../../../components";
// api
import { useStyletron } from 'baseui';
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { VscFlame } from 'react-icons/vsc';
import { useMemo } from 'react'
import { Block } from 'baseui/block'
import { schema as schemaMultistate, SmallPanel as MSSmallPanel } from '../../../Devices/MultiState'
import { Badge } from 'baseui/badge'
import { FormattedMessage } from 'react-intl'
import { themedUseStyletron } from '../../../../theme/customTheme'

export function OverviewPanel(props: TP_HeatingGenerator) {
    const [css, theme] = themedUseStyletron();

    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const { flowPipe, pFlowPipe, sFlowPipe, outletPipe, state, stateSW, efficiency, puffer, pOutletPipe, sOutletPipe, heatingCoil, headtingGenerators } = useMemo(() => {
        return {
            flowPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_FlowPipe"),
            pFlowPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe"),
            sFlowPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryFlowPipe"),
            outletPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_OutletPipe"),
            state: children?.find((v: any) => v.schema === schemaMultistate),
            stateSW: children?.find((v: any) => v.schema === schemaMultistateSwitch),
            efficiency: children?.find((v: any) => v.schema === "AutomationApps.Utils.Efficiency"),
            puffer: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Puffers.SP_Puffer"),
            pOutletPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe"),
            sOutletPipe: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryOutletPipe"),
            heatingCoil: children?.find((v: any) => v.schema === "AutomationApps.SubPlants.HeatingCoils.SP_HeatingCoil"),
            headtingGenerators: children?.filter((v: any) => v.schema === "AutomationApps.SubPlants.HeatingGenerators.SP_HeatingGenerator")
        }
    }, [children])


    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight}  {...props} icon={<VscFlame size={'100%'}></VscFlame>}>
            <Block display={'inline-flex'} gridGap={theme.sizing.scale400}>
                {props.isOn && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.ON" defaultMessage="On" />} />}
                {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
                {stateSW && <MSSwitchSmallPanel {...stateSW}></MSSwitchSmallPanel>}
                {state  && <MSSmallPanel {...state}></MSSmallPanel>}
            </Block>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <>

                    {(heatingCoil && props.showCoil) &&
                        <HeatingCoilPanel {...heatingCoil}></HeatingCoilPanel>
                    }

                    <Block display='flex' flexDirection={'row'} gridGap={theme.sizing.scale500}>
                        {headtingGenerators?.map((item: any, index: number) => (
                            <HeatingGeneratorPanel   {...item}></HeatingGeneratorPanel>
                        ))}
                    </Block>

                    {flowPipe && !pFlowPipe && !sFlowPipe &&
                        <>
                            {props.showFlow ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...flowPipe}></PipePanelTrend>) : (
                                    <PipePanel {...flowPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {pFlowPipe && !sFlowPipe &&
                        <>
                            {props.showFlow ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...pFlowPipe}></PipePanelTrend>) : (
                                    <PipePanel {...pFlowPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {sFlowPipe &&
                        <>
                            {props.showFlow ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...sFlowPipe}></PipePanelTrend>) : (
                                    <PipePanel {...sFlowPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {puffer &&
                        <>
                            {props.showPuffer ? (
                                props.showTrendPanels ? (
                                    <PufferPanelTrend {...puffer}></PufferPanelTrend>) : (
                                    <PufferPanel {...puffer}></PufferPanel>)) : (<></>)
                            }
                        </>
                    }

                    {outletPipe && !pOutletPipe && !sOutletPipe &&
                        <>
                            {props.showOutlet ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...outletPipe}></PipePanelTrend>) : (
                                    <PipePanel {...outletPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {pOutletPipe && !sOutletPipe &&
                        <>
                            {props.showOutlet ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...pOutletPipe}></PipePanelTrend>) : (
                                    <PipePanel {...pOutletPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {sOutletPipe &&
                        <>
                            {props.showOutlet ? (
                                props.showTrendPanels ? (
                                    <PipePanelTrend {...sOutletPipe}></PipePanelTrend>) : (
                                    <PipePanel {...sOutletPipe}></PipePanel>)) : (<></>)
                            }
                        </>
                    }
                    {efficiency &&
                        <>
                            {props.showEfficiency ? (
                                <EfficiencyPanel {...efficiency}></EfficiencyPanel>) : (<></>)
                            }
                        </>
                    }
                </>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}